const HeroSection = () => {
  return (
    <section className="bg-gradient-to-br from-primary to-blue-800 py-20 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <div className="inline-block bg-white/20 px-4 py-2 rounded-full mb-6">
            <span className="font-bold text-sm">INFRASTRUCTURE DEVELOPMENT</span>
          </div>
          <h1 className="text-5xl font-black mb-6">
            Our Projects
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            Expanding and upgrading water and sewerage infrastructure to serve our growing community
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
